export default "__VITE_ASSET__dFfZs4f2__"